import { IPartialTheme } from '@fluentui/react/lib/Styling';

const theme: IPartialTheme = {
    defaultFontStyle: { fontFamily: "Roboto, sans-serif" },
}

export default theme;